export class RatingConverter {
    convertRating(rating) {
        const fiveStarRating = (rating / 100) * 5;
        // Round the rating to the nearest 0.5
        const roundedRating = Math.round(fiveStarRating * 2) / 2;
        // Return the converted rating
        return roundedRating;
    }
}
